import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PlatformRecommend from './components/PlatformRecommend';
import CategoryNav from './components/CategoryNav';
import HotMovies from './components/HotMovies';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PlatformRecommend />
        <CategoryNav />
        <HotMovies />
        <Features />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}